import type { OverlayDismissHandlerProps } from '@/components/ui/overlay-dismiss-handlers'

function isPortaledPopoverTarget(target: EventTarget | null): boolean {
  if (!(target instanceof Element)) {
    return false
  }

  return (
    target.closest('[data-slot="popover-content"]') != null ||
    target.closest('[data-slot="popover-positioner"]') != null ||
    target.closest('[data-slot="command"]') != null ||
    target.closest('[data-slot="command-list"]') != null ||
    target.closest('[data-slot="command-item"]') != null
  )
}

/** Prevent modal overlays from swallowing clicks on Base UI popovers portaled outside content. */
export const dialogPortaledPopoverGuard: OverlayDismissHandlerProps = {
  onPointerDownOutside: (event) => {
    if (isPortaledPopoverTarget(event.target)) {
      event.preventDefault()
    }
  },
  onInteractOutside: (event) => {
    if (isPortaledPopoverTarget(event.target)) {
      event.preventDefault()
    }
  },
  onFocusOutside: (event) => {
    if (isPortaledPopoverTarget(event.target)) {
      event.preventDefault()
    }
  },
}
